import {override} from 'mobx';
import {AutoAnimation} from "../../../../../infrastructure/models/animation/auto-animation";
import {BasePenaltyMissedAnimationSetModel} from "../../../../../infrastructure/models/animation/game/animation-set-models/goal/base-penalty-missed-animation-set-model";
import {ANIMATION_TIMES} from "../../../../../core/consts";

export class GameCenterHeaderPenaltyMissedAnimationSetModel extends BasePenaltyMissedAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    this.duration = ANIMATION_TIMES.GAME_CENTER.generalAnimationTime;
  }

  @override get statusText(): AutoAnimation {
    const enterAnimation: String = 'scale-up-center-appear';
    const mainAnimation: String = 'visible';
    const leaveAnimation: String = 'scale-up-center-disappear';

    const statusText = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return statusText;
  }

  @override get homeCompetitorLogo(): AutoAnimation {
    const enterAnimation: String = 'scale-up-center-disappear';
    const mainAnimation: String = 'hide';
    const leaveAnimation: String = 'scale-up-center-appear';

    const homeCompetitorLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation,'',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return homeCompetitorLogo;
  }

  @override get homeCompetitorEventLogo(): AutoAnimation {
    const enterAnimation: String = ['scale-up-center-appear','game-center-header-animation-logo'].join(' ');
    const mainAnimation: String = ['visible','game-center-header-card-animation-logo'].join(' ');
    const leaveAnimation: String = ['scale-up-center-disappear','game-center-header-animation-logo'].join(' ');

    const homeCompetitorEventLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation,'',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return homeCompetitorEventLogo;
  }

  @override get awayCompetitorLogo(): AutoAnimation {
    const enterAnimation: String = 'scale-up-center-disappear';
    const mainAnimation: String = 'hide';
    const leaveAnimation: String = 'scale-up-center-appear';

    const awayCompetitorLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation,'',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return awayCompetitorLogo;
  }

  @override get awayCompetitorEventLogo(): AutoAnimation {
    const enterAnimation: String = ['scale-up-center-appear','game-center-header-animation-logo'].join(' ');
    const mainAnimation: String = ['visible','game-center-header-card-animation-logo'].join(' ');
    const leaveAnimation: String = ['scale-up-center-disappear','game-center-header-animation-logo'].join(' ');

    const awayCompetitorEventLogo = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation,'',
      0, this.durationByRatio(0.95), this.durationByRatio(0.05));

    return awayCompetitorEventLogo;
  }
}
